import PrimaryContactCard from '@/components/dashboard/PrimaryContactCard'
import AccountHotlinks from '@/components/dashboard/widgets/AccountHotlinks.vue'
import ServiceCalendarCard from '@/components/dashboard/widgets/ServiceCalendarCard.vue'
import AccountTasksCard from '@/components/tasks/AccountTasksCard'
import AlpsPrimaryContactCard from '@/components/dashboard/widgets/AlpsPrimaryContactCard.vue'
import PolicySummaryCard from '@/components/dashboard/widgets/PolicySummaryCard.vue'

// Must match java side, DashboardWidget.java
export const options = Object.freeze({
  ACCOUNT_CONTACT: 'AccountContact',
  QUICK_LINKS: 'QuickLinks',
  SERVICE_CAL: 'ServiceCalendar',
  ACCOUNT_TASKS: 'AccountTasks',
  ALPS_CONTACT: 'AlpsAccountContact',
  POLICY_SUMMARY: 'PolicySummary',
})

export const widgets = {
  [options.ACCOUNT_CONTACT]: {
    type: options.ACCOUNT_CONTACT,
    component: PrimaryContactCard,
  },
  [options.QUICK_LINKS]: {
    type: options.QUICK_LINKS,
    component: AccountHotlinks,
  },
  [options.SERVICE_CAL]: {
    type: options.SERVICE_CAL,
    component: ServiceCalendarCard,
  },
  [options.ACCOUNT_TASKS]: {
    type: options.ACCOUNT_TASKS,
    component: AccountTasksCard,
  },
  [options.ALPS_CONTACT]: {
    type: options.ALPS_CONTACT,
    component: AlpsPrimaryContactCard,
  },
  [options.POLICY_SUMMARY]: {
    type: options.POLICY_SUMMARY,
    component: PolicySummaryCard,
  },
}
export const defaultOptions = [options.ACCOUNT_CONTACT, options.QUICK_LINKS, options.SERVICE_CAL, options.ACCOUNT_TASKS]
